import React, { useEffect, useState } from "react";
// import alertIcon from "../../../images/alert.png";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";
import { getActivationToggleAction, getSingleTelnetAction, getTelnetActivityAction, setActivationToggleAction, setActivationToggleErrorAction } from "../../../store/reducers/adminClientsSlice";
import { useSelector } from "react-redux";
import Notification from "../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
interface ActivationPopupProps {
  activateRec?: string;
  onHide?: () => void;
  clientDetails?: any;
  activateModalShow: boolean;
  setActivateModalShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
}
const ActivationPopup: React.FC<ActivationPopupProps> = ({
  activateRec,
  onHide,
  activateModalShow,
  setActivateModalShow,
  setShowSuccessMessage,
  clientDetails,
}) => {
  
  const dispatch = useDispatch();
  const classes = useStyles();

  const { isClientToggleError, isClientToggleResponse } = useSelector(
    (state: any) => state?.adminClients
  );

  const submitHandler = () => {
    // setIsAction(true);
    const payload = {
      tenantId: clientDetails?.client_id,
      isActive: clientDetails?.is_active ? false : true,
      status: clientDetails?.is_active ? "INACTIVE" : "ACTIVE",
    };
    console.log("payload", { ...payload });
    dispatch(getActivationToggleAction({ ...payload }));
  };

  useEffect(() => {
    if (isClientToggleResponse===true) {
      dispatch(getSingleTelnetAction(clientDetails?.client_id));
      dispatch(getTelnetActivityAction(clientDetails?.client_id));
      setActivateModalShow(false);
      dispatch(setActivationToggleAction(false));
    }
  }, [isClientToggleResponse]);

  const closeModel = () => {
    setActivateModalShow(false);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    
    dispatch(setActivationToggleErrorAction(false));
  };

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition

  return (
    <Popup
      open={activateModalShow}
      title={clientDetails?.is_active ?"Deactivation":"Activation"}
      onHide={closeModel}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          {isClientToggleError ? (
            <CustomButton variant="outlined" title="Close" onClick={closeModel} />
          ) : (
            <>
              <CustomButton variant="outlined" title="No" onClick={onHide} />
              <CustomButton title="Yes" onClick={submitHandler} />
            </>
          )}
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          {/* <img src={alertIcon} alt="icons" /> */}
          {isClientToggleError ? (
            <Notification />
          ) : (
            <Alert
              sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
              severity="warning"
            >
              Are you sure, you want to{" "}
              {clientDetails?.is_active ? "deactivate" : "activate"} this
              client?
            </Alert>
          )}
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default ActivationPopup;
